import { configureStore } from '@reduxjs/toolkit';
import progressReducer from '../reducers/progress.Slice';
import idleReducer from '../reducers/Idle.Slice';

export const store = configureStore({
  reducer: {
    progress: progressReducer,
    idle: idleReducer,
  },
})